<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2022-01-13 21:06:06
 * @LastEditors: 诺
 * @LastEditTime: 2022-12-06 16:05:41
-->

<template>
  <div class="ActBaseBottom" ref="box">
    <div class="shareBtn" v-if="showShareBtn">
      <div class=" default act-text-stroke" @click="$emit('lightup', 'share')">呼朋唤友</div>
    </div>
    {{ configInfo.disclaimer || "本次活动最终解释权归主办方远洋集团。" }}
  </div>
</template>
<script>
export default {
  props: {
    configInfo: Object,
    showShareBtn: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
  },
  computed: {
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.ActBaseBottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  /* height: 20px; */
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  line-height: 18px;
  z-index: 100;
  background: linear-gradient(0deg, #131111 0%, rgba(0, 0, 0, 0) 100%);
}

.shareBtn {
  width: 280px;
  margin: 26px auto 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .default {
    flex: 1;
    height: 44px;
    font-size: 16px;
    animation: debounce 5s ease infinite;
    background: #CD934F;;
    border: 1px solid #FFE3B3;
    box-shadow: 0px 2px 4px 0px rgba(25, 1, 1, 0.6);
    border-radius: 22px;
    font-weight: bold;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .shareImg {
    flex: 1;
    margin-right: 16px;
    height: 48px;

    img {
      width: 100%;
      height: 48px;
      object-fit: contain;
    }
  }
}

@keyframes debounce {
  0% {
    transform: rotate(-5deg);
  }

  4% {
    transform: rotate(5deg);
  }

  8% {
    transform: rotate(-5deg);
  }

  12% {
    transform: rotate(5deg);
  }

  16% {
    transform: rotate(-5deg);
  }

  20% {
    transform: rotate(5deg);
  }

  25% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(0);
  }
}
</style>
